module.exports = __webpack_public_path__ + "static/media/grains_1.d32c27c3.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/grains/grains_1.csv
// module id = 729
// module chunks = 0